import { Body, Box } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

interface Props {
  visible: boolean;
}

const SecondTeamValue: React.FC<Props> = ({ visible }) => (
  <Box
    display={visible ? 'block' : 'none'}
    width={{ base: '100%', desktop: 584 }}
  >
    <StaticImage
      placeholder="blurred"
      src="../../../assets/images/our_values_2.png"
      alt="our values 1"
    />
    <Body mt={600} mb={{ desktop: 900 }} size={500} maxW="584px">
      We have a strong bias towards action, and we learn and adapt along the
      way. We don&apos;t get bogged down by indecision. We pick a lane and we
      hit the gas.
    </Body>
  </Box>
);

export default SecondTeamValue;
